import { Language, MemberStatusEnum, Sex } from '@/api/enum/common.enum';

export const APPROACH_SOURCE_LIST = [
	{ id: 0, name: 'Family members/carers' },
	{ id: 1, name: 'Self-approach' },
	{ id: 2, name: 'Referral' },
];

export const SEX_LIST = [
	{ id: Sex.male, name: 'Male' },
	{ id: Sex.female, name: 'Female' },
];
export const ZH_SEX_LIST = [
	{ id: Sex.male, name: '男' },
	{ id: Sex.female, name: '女' },
];

export const SEX_ZH_LIST = [
	{ id: Sex.male, name: '男' },
	{ id: Sex.female, name: '女' },
];

export const ENQUIRY_METHOD_LIST = [
	{ id: 0, name: 'Drop-in' },
	{ id: 1, name: 'Phone' },
	{ id: 2, name: 'Fax' },
];

export const LANGUAGE_LIST = [
	{ id: Language.chinese, name: 'Chinese' },
	{ id: Language.english, name: 'English' },
];
export const LANGUAGE_ZH_LIST = [
	{ id: Language.chinese, name: '中文' },
	{ id: Language.english, name: 'English' },
];

export const PREFIX_LIST = [
	{ id: 0, name: 'Mr.' },
	{ id: 1, name: 'Ms.' },
	{ id: 2, name: 'Dr.' },
];
export const FIELD_UNIT_STATUS = [
	{ id: false, name: 'Active' },
	{ id: true, name: 'Inactive' },
];

export const AGENCY_LIST = [
	{ id: 0, name: 'Active' },
	{ id: 1, name: 'Intake' },
];

export const ISCASE_LIST = [
	{ id: true, name: 'Yes' },
	{ id: false, name: 'No' },
];

export const YESNO = [
	{ id: true, name: 'Yes' },
	{ id: false, name: 'No' },
];
export const YESNOLIST = [
	{ id: 1, name: 'Yes' },
	{ id: 0, name: 'No' },
];
export const CONSENT_OBTAINED_LIST = [
	{ id: 1, name: 'Yes' },
	{ id: 0, name: 'No' },
	{ id: 2, name: 'To be confirmed' },
];
// Who the worker may contact direct, once resultCanContacted is chosen. The
// exported PDF circles one of the two, so exactly one must be picked.
export const RESULT_CAN_CONTACTED_TARGET_LIST = [
	{ id: 0, name: 'the case' },
	{ id: 1, name: 'the carer' },
];
export const ONOFF = [
	{ id: 1, name: 'On' },
	{ id: 0, name: 'Off' },
];
export const ONOFF_BOOLEAN = [
	{ id: true, name: 'On' },
	{ id: false, name: 'Off' },
];

export const AGE_RANGE_LIST = [
	{ id: 0, name: 'Under 21' },
	{ id: 1, name: '21 - 30' },
	{ id: 2, name: '31 - 40' },
	{ id: 3, name: '41 - 50' },
	{ id: 4, name: '51 - 60' },
	{ id: 5, name: '61 - 70' },
	{ id: 6, name: '71 - 80' },
	{ id: 7, name: 'Over 80' },
];

export const EMERGENCY_CONTACT = [
	{ id: true, name: '有' },
	{ id: false, name: '否' },
];

export const ZH_YESNO = [
	{ id: true, name: '是' },
	{ id: false, name: '否' },
];

export const CONSENT = [
	{ id: true, name: '同意' },
	{ id: false, name: '不同意' },
];

export const ACCEPT = [
	{ id: true, name: '接納' },
	{ id: false, name: '不接納' },
];

export const PAUSEORMOVEWAITING = [
	{
		id: 0,
		name: 'N/A',
	},
	{
		id: 1,
		name: 'Pause enrolment',
	},
	{
		id: 2,
		name: 'Move to waiting list',
	},
];
